export const enum FileStatuses {
	COMPLETE = 'complete',
	LOADING = 'loading',
	ERROR = 'error',
	WARNING = 'warning',
}

export const enum ViewIcons {
	UPLOAD = 'file-upload',
	REFRESH = 'refresh',
	LOCK = 'lock',
}
